import { all, fork } from 'redux-saga/effects'
import invitesFormSaga from './invitesFormSaga'
import organizationAdminUsersGetSaga from './organizationAdminUsersGetSaga'
import organizationAdminUsersPostSaga from './organizationAdminUsersPostSaga'
import resendInviteSaga from './resendInviteSaga'
import resendProtrackSaga from './resendProtrackSaga'
import saveOrganizationSuccess from './saveOrganizationSuccess'
import saveOrganizationSprintSuccess from './saveOrganizationSprintSuccess'
import getLoginLinkAsUserSaga from './getLoginLinkAsUserSaga'
import updateUserTeamsSaga from './updateUserTeamsSaga'
import updateOrganizationProtrackLevelTeamsSaga from './updateOrganizationProtrackLevelTeamsSaga'
import availableLanguageSaga from './availableLanguagesSaga'
import manageUsersSaga from './manageUsersSaga'
import { checkDomainRequestSaga } from './index'
// remove it from here in the future, place it to all 'upload image' sagas
import uploadOrganizationLogoSaga from './uploadOrganizationLogoSaga'
import postPartnersLinksSuccessSaga from './postPartnersLinksSuccessSaga'
import fetchUsersSaga from './fetchUsersSaga'
import fetchUsersByStatusSaga from './fetchUsersByStatusSaga'
import deleteOrganizationUserBulkSaga from './deleteOrganizationUserBulkSaga'
import updateFilterByAfterSingleEmailUpdateSaga from './updateFilterByAfterSingleEmailUpdateSaga'

export default function* adminOrganizationSaga() {
  yield all([
    fork(invitesFormSaga),
    fork(organizationAdminUsersGetSaga),
    fork(organizationAdminUsersPostSaga),
    fork(resendInviteSaga),
    fork(resendProtrackSaga),
    fork(uploadOrganizationLogoSaga),
    fork(saveOrganizationSuccess),
    fork(saveOrganizationSprintSuccess),
    fork(availableLanguageSaga),
    fork(getLoginLinkAsUserSaga),
    fork(checkDomainRequestSaga),
    fork(updateUserTeamsSaga),
    fork(updateOrganizationProtrackLevelTeamsSaga),
    fork(manageUsersSaga),
    fork(postPartnersLinksSuccessSaga),
    fork(fetchUsersByStatusSaga),
    fork(fetchUsersSaga),
    fork(deleteOrganizationUserBulkSaga),
    fork(updateFilterByAfterSingleEmailUpdateSaga),
  ])
}
